// removed by extract-text-webpack-plugin
module.exports = {"container":"_37OPu","card":"_1Fhsz","moreButton":"_2nR4V","cover":"_2r3ng","uploadCoverButton":"_2SkiL","uploadPhotoButton":"_1bJUV","photo":"_3Y75r","flexContainer":"lF2sX","userInfo":"nPerC","name":"BDc7Z","nameFieldWrapper":"EzZpx","editIcon":"_38cDs","nameField":"_2lpuH","nameInput":"_2FfQj","date":"_2cshH","childrenContainer":"_2uP0o","viewProfileEdit":"_3JLIl","cancelButton":"_1AqaR","statsContainer":"_3l5zw"};


//////////////////
// WEBPACK FOOTER
// ./app/components/profile/profile.scss
// module id = 1329
// module chunks = 0